
import React from 'react';

interface ContentSectionProps {
  id: string;
  title: string;
  children: React.ReactNode;
}

const ContentSection: React.FC<ContentSectionProps> = ({ id, title, children }) => {
  return (
    <section id={id} className="bg-white p-6 sm:p-8 rounded-xl shadow-md">
      <h2 className="text-2xl sm:text-3xl font-bold mb-6 text-sky-800 border-b-2 border-sky-200 pb-3">
        {title}
      </h2>
      <div className="prose prose-slate max-w-none prose-p:text-slate-600 prose-li:text-slate-600">
        {children}
      </div>
    </section>
  );
};

export default ContentSection;
